export const ModalMode = {
  NEW: 'new',
  EDIT: 'edit',
  CLOSED: 'closed',
};
